import * as React from 'react';
import { Box } from '../../Box/Box.js';
import { useThemeContext } from '../../../contexts/session/Theme.js';

var NavigatorLayout = function NavigatorLayout(_ref) {
  var align = _ref.align,
    acceptPointer = _ref.acceptPointer,
    visible = _ref.visible,
    disabled = _ref.disabled,
    width = _ref.width,
    height = _ref.height,
    mb = _ref.mb,
    mx = _ref.mx,
    ms = _ref.ms,
    pb = _ref.pb,
    px = _ref.px,
    onKeyDown = _ref.onKeyDown,
    zIndex = _ref.zIndex,
    children = _ref.children;
  var theme = useThemeContext();
  return /*#__PURE__*/React.createElement(Box, {
    pointerEvents: acceptPointer || !disabled && visible ? 'auto' : 'none',
    opacity: visible ? 1 : 0,
    transition: "opacity 0.35s ease-in-out",
    position: "absolute",
    "aria-hidden": !visible,
    zIndex: zIndex,
    onKeyDown: onKeyDown,
    top: "0",
    bottom: !acceptPointer && mb ? theme.spacing[mb] : '0',
    pb: pb,
    px: px,
    display: "flex",
    alignItems: "center",
    justifyContent: align === 'start' ? 'flex-start' : 'flex-end',
    start: align === 'start' ? 0 : undefined,
    end: align === 'end' ? 0 : undefined,
    ms: ms,
    mx: mx,
    width: width,
    height: height
  }, children);
};
var NavigatorLayoutMemoized = /*#__PURE__*/React.memo(NavigatorLayout);
NavigatorLayoutMemoized.displayName = 'NavigatorLayout';

export { NavigatorLayoutMemoized as NavigatorLayout };
//# sourceMappingURL=NavigatorLayout.js.map
